import { useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuthToken } from 'datastage/utils/localStorageService.js';
import { setSessionStart } from '../../datastage/store/auth';
import { isDealVersionFileDownloadUrl } from '../../datastage/utils/dealVersionDownloadRedirect.js';

export const AuthVerify = ({ logOut }) => {
    const dispatch = useDispatch();
    const { sessionStart } = useSelector((s) => s.auth);
    const token = getAuthToken();
    const navigate = useNavigate();
    const location = useLocation();

    // Set session start if not set
    useEffect(() => {
        if (!sessionStart) {
            dispatch(setSessionStart(moment.utc().toISOString()));
        }
    }, [sessionStart, dispatch]);

    // Check token expiration and handle navigation
    useEffect(() => {
        if (!token) return;
        try {
            const decodedJwt = jwtDecode(token);
            // Handle tokens without exp claim - treat as non-expiring
            const hasExp = typeof decodedJwt.exp === 'number';
            const isExpired = hasExp && decodedJwt.exp * 1000 < Date.now();
            if (isExpired) {
                dispatch(setSessionStart(''));
                logOut();
            } else {
                const panel = localStorage.getItem('activePanel');
                const postLoginRedirect = localStorage.getItem('postLoginRedirect');
                // activePanel must be an in-app path (e.g. /dealVersion). Never navigate to absolute
                // API URLs (legacy bug: file download postLoginRedirect was stored as activePanel).
                if (panel && /^https?:\/\//i.test(panel)) {
                    localStorage.removeItem('activePanel');
                } else if (panel && location.pathname !== panel) {
                    // Don't navigate to activePanel if there's a pending file download redirect.
                    // Let AuthProvider.checkCredentials() handle the download instead.
                    if (postLoginRedirect && isDealVersionFileDownloadUrl(postLoginRedirect)) {
                        return;
                    }
                    navigate(panel);
                }
            }
        } catch {
            dispatch(setSessionStart(''));
            logOut();
        }
    }, [token, dispatch, logOut, navigate, location.pathname]);

    return null;
};
